import { render } from "./AddUserToEvent.vue?vue&type=template&id=2137c039&scoped=true"
import script from "./AddUserToEvent.vue?vue&type=script&lang=js"
export * from "./AddUserToEvent.vue?vue&type=script&lang=js"

import "./AddUserToEvent.vue?vue&type=style&index=0&id=2137c039&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2137c039"]])

export default __exports__